export const getApiBaseUrl = (): string =>
  window.env?.VITE_API_URL ?? import.meta.env.VITE_API_URL;

export const getDevPortalBaseUrl = (): string =>
  window.env?.VITE_DEV_PORTAL_URL ?? import.meta.env.VITE_DEV_PORTAL_URL;

export const isLocalEnvironment = (): boolean => {
  const baseUrl = getApiBaseUrl();

  return baseUrl?.includes('localhost');
};

export const getOtelAppEnvironment = (host: string): string => {
  if (host.includes('download.airkey')) return 'prod';
  if (host.includes('download.dev-airkey') || host.includes('-qa.clouddqt')) return 'qa';
  if (host.includes('-dev.clouddqtext') || host.includes('-dev.clouddqt')) return 'dev';
  return 'local';
};

export const getOtelGatewayBase = (environment: string): string => {
  if (environment === 'prod') return 'https://otelservices-web.cloud.capitalone.com:443';
  if (environment === 'local') return 'http://localhost:4318';
  return 'https://otelservices-web.clouddqt.capitalone.com:443';
};
